import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import MainFooter from '../../components/MainFooter'

const DashboardAuthLayout = props => {
  const { children, showFooter } = props

  return (
    <>
      <div>{children}</div>
      {showFooter && <MainFooter />}
    </>
  )
}

DashboardAuthLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
}

export default inject('commonStore')(observer(DashboardAuthLayout))
